import api from './api';

class PaymentService {
  // Create membership order (online or cash)
  async createMembershipOrder(data) {
    const response = await api.post('/payments/create-order', data);
    return response.data;
  }

  // Confirm cash payment (admin only)
  async confirmCashPayment(data) {
    const response = await api.post('/payments/confirm-cash', data);
    return response.data;
  }

  // Get member payment history
  async getMemberPayments(memberId) {
    const response = await api.get(`/payments/member/${memberId}`);
    return response.data;
  }

  // Get invoice
  async getInvoice(invoiceId) {
    const response = await api.get(`/payments/invoice/${invoiceId}`);
    return response.data;
  }

  // Get invoice details
  async getInvoiceDetails(invoiceId) {
    const response = await api.get(`/payments/invoice/${invoiceId}/details`);
    return response.data;
  }

  // Get payment status (for polling)
  async getPaymentStatus(invoiceId) {
    const response = await api.get(`/payments/invoice/${invoiceId}/status`);
    return response.data;
  }

  // Download invoice as PDF
  async downloadInvoicePDF(invoiceId) {
    const response = await api.get(`/payments/invoice/${invoiceId}/pdf`, {
      responseType: 'blob'
    });
    return response.data;
  }
}

export default new PaymentService();
